var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_01_strategie",
    "data-name": "01_strategie",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(38.699 12.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4518",
    "data-name": "Path 4518",
    d: "M313.962,97.791a94.939,94.939,0,0,1-2.182,18.572,64.607,64.607,0,0,0-.146-19.9c-1.28-7.191-5.527-16.174-13.438-17.727a14.728,14.728,0,0,0-7.221.515l-.027-.158a11.815,11.815,0,0,0-2.319-5.6h0c6.051-2.857,13.447-2.488,18.388,2.39,5.539,5.471,6.944,14.406,6.944,21.912Z",
    transform: "translate(-241.422 -63.354)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4519",
    "data-name": "Path 4519",
    d: "M176.734,135.1c-3,6.539-6.23,12.215-6.3,20.48,9.873,14.825,58.825,11.459,55.914-6.923-3.182-11.676.563-28.088,2.417-37.294a64.607,64.607,0,0,0-.146-19.9c-1.863-10.132-8.59-20.965-20.659-17.212-.631-3.679-1.893-6.643-7.221-9.676,2.756,10.245-5.59,13.849-5.59,13.849.289,1.827.682,3.113-.827,4.649a76.089,76.089,0,0,0-5.64,6.563,13.884,13.884,0,0,0-2.5,4.988A23.2,23.2,0,0,1,184.8,98.57c-4.194,6.072-9.149,13.483-12.819,19.623-1.729,2.9-.631,3.339-.994,5.622a11.658,11.658,0,0,0-.125,2.771,5.393,5.393,0,0,0,2.378,4.509c1.4.81,3.295.732,5.393-.336.173-.182-1.423,3.328-1.9,4.351Z",
    transform: "translate(-158.403 -58.356)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4520",
    "data-name": "Path 4520",
    d: "M281.3,59.059c-4.39-2.506-9.938-2.027-14.382.068-.048-.027-.17.158-.327.438a15.747,15.747,0,0,0-5.149-4.277l.027.1a27.22,27.22,0,0,0-4.6-2.741c4.459-1.658,10.042-1.911,14.028.4Z",
    transform: "translate(-219.108 -49.07)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4521",
    "data-name": "Path 4521",
    d: "M146.517,109.123a11.658,11.658,0,0,0-.125,2.771,5.393,5.393,0,0,0,2.378,4.509L138,110.18a5.4,5.4,0,0,1-2.378-4.5,12.58,12.58,0,0,1,.134-2.777c.363-2.253-.714-2.759.994-5.616,3.661-6.14,8.625-13.557,12.813-19.629a22.785,22.785,0,0,0,1.384-3.941,13.7,13.7,0,0,1,2.491-4.982,77.953,77.953,0,0,1,5.64-6.563c1.512-1.551,1.125-2.807.833-4.649,0,0,8.349-3.6,5.584-13.849l10.774,6.218c2.756,10.245-5.59,13.849-5.59,13.849.289,1.827.682,3.113-.827,4.649a77.187,77.187,0,0,0-5.64,6.563,13.861,13.861,0,0,0-2.5,4.988,23.285,23.285,0,0,1-1.378,3.941c-4.194,6.072-9.149,13.483-12.819,19.623-1.729,2.9-.631,3.339-.994,5.622Z",
    transform: "translate(-133.933 -43.67)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4522",
    "data-name": "Path 4522",
    d: "M198.09,190.843c3.345-1.714,6.477-5.938,7.64-10.289a6.23,6.23,0,0,1,2.048-3.188,17.635,17.635,0,0,1,9.411-3.723,12.037,12.037,0,0,0,4.548-1.277c9.509-5.488,11.712-15.688,9.048-20.3-1.232-2.131-3.334-2.485-5.92-.994",
    transform: "translate(-177.83 -118.464)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4523",
    "data-name": "Path 4523",
    d: "M196.726,304.351c7.334,4.125,11.894,9.893,11.894,16.275v11.364c0,12.542-17.593,22.71-39.3,22.71s-39.3-10.167-39.3-22.71V320.625c0-8.09,7.322-15.191,18.346-19.215",
    transform: "translate(-130.02 -224.697)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 156,
    height: 156,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.64a25d1b85846d964e36e7bfa53ffac5.svg";
export { ForwardRef as ReactComponent };